<template>
    <va-edit-layout>
        <SellerDealPaymentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></SellerDealPaymentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
